export default class Featured {


	// Constructor
	constructor(asscroll, menu, element) {

		this.asscroll = asscroll;
		this.asscrollCurrentPos = 0;
		this.asscrollElement = (asscroll) ? asscroll.scrollElements : null;

		this.menu = menu;

		this.element = element;
		this.buttonBg = this.element.querySelector('.featured--bg');
		this.buttonClose = this.element.querySelector('.featured--close');
		this.buttonMenu = document.querySelector('.featured--button');
		this.buttonMenuText = this.buttonMenu.querySelector('span');
		this.panel = this.element.querySelector('.featured--panel');

		this.items = [];
		const selectors = [
			'a',
			'button'
		];
		let i, ii, l, ll, item;
		for (i=0, l=selectors.length; i<l; i++) {
			item = Array.prototype.slice.call(this.element.querySelectorAll(selectors[i]), 0);
			for (ii=0, ll=item.length; ii<ll; ii++) {
				this.items.push(item[ii]);
			}
		}

		this.triggerClicked = this.triggerClicked.bind(this);
	}

	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.asscrollCurrentPos;
		delete this.asscrollElement;
		delete this.buttonBg;
		delete this.buttonClose;
		delete this.buttonMenu;
		delete this.buttonMenuText;
		delete this.items;
		delete this.panel;
	}
	enable() {
		this.buttonBg.addEventListener('click', this.triggerClicked);
		this.buttonClose.addEventListener('click', this.triggerClicked);
		this.buttonMenu.addEventListener('click', this.triggerClicked);
		this.updateState();
	}
	disable() {
		this.items.forEach(function(item) {
			item.removeAttribute('aria-hidden');
			item.removeAttribute('tabindex');
		});
		this.buttonBg.removeEventListener('click', this.triggerClicked);
		this.buttonClose.removeEventListener('click', this.triggerClicked);
		this.buttonMenu.removeEventListener('click', this.triggerClicked);
	}


	// Hide & Show
	show() {

		this.menu.showModal(this);

		document.body.classList.add('show-featured');
		this.updateState();

		if (this.asscroll) {
			this.asscrollCurrentPos = this.asscroll.currentPos;

			this.asscroll.disable();
			this.asscroll.enable({ newScrollElements: this.panel, reset: true });
		}
	}
	hide() {

		this.menu.hideModal();

		document.body.classList.remove('show-featured');
		this.updateState();

		if (this.asscroll) {
			this.asscroll.disable();
			this.asscroll.currentPos = this.asscrollCurrentPos;
			this.asscroll.enable({ newScrollElements: this.asscrollElement });
		}
	}


	// Event Handlers
	triggerClicked(event) {
		event.preventDefault();
		if (document.body.classList.contains('show-featured')) {
			this.hide();
		} else {
			this.show();
		}
	}


	// Helpers
	updateState() {
		if (document.body.classList.contains('show-featured')) {
			this.element.setAttribute('aria-hidden', 'false');
			this.buttonMenu.setAttribute('aria-expanded', 'true');
			this.buttonMenuText.innerHTML = this.buttonMenu.getAttribute('data-text-hide');
			this.items.forEach(function(item) {
				item.removeAttribute('aria-hidden');
				item.removeAttribute('tabindex');
			});
		} else {
			this.element.setAttribute('aria-hidden', 'true');
			this.buttonMenu.setAttribute('aria-expanded', 'false');
			this.buttonMenuText.innerHTML = this.buttonMenu.getAttribute('data-text-show');
			this.items.forEach(function(item) {
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			});
		}
	}


}
